import { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import * as Pf from "./Portfolio-styles";
import PortfolioQuickView from "./PortfolioQuickView";
import { fetchProductsMain } from "../../../api/products";
import PortFolioSingleProduct from "./PortfolioSingleProduct";
import { PortfolioListSet } from "../../../api/portfolio";
import { connect } from "react-redux";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const Portfolio = ({ dummyList }) => {
  const [active, setActive] = useState(0);
  const [selectedTags, setSelectedTags] = useState("P0001");
  const [portfolios, setPortfolios] = useState({});
  const [activeList, setActiveList] = useState([]);

  const handleClick = (i, target) => {
    setSelectedTags(target);
    setActive(active == i ? 0 : i);
    setActiveList(portfolios[target]);
  };

  const fetchPortfolio = async () => {
    const body = {
      modes: "ListSet",
    };
    const res = await PortfolioListSet(body);
    if (res.Code === "0000") {
      setPortfolios(res.Data.rows);
      setActiveList(res.Data.rows["P0001"]);
    } else {
      console.error(res?.Data?.Msg);
    }
  };

  useEffect(() => {
    fetchPortfolio();
  }, []);

  return (
    <>
      <Layout
        parent="홈"
        sub="맞춤제작"
        subTitle="포트폴리오"
        pageTitle={SeoMeta.portfolio.title}
        pageDesc={SeoMeta.portfolio.description}
        pageKeyword={SeoMeta.portfolio.keywords}
      >
        <Pf.Container className="container">
          <Pf.TitleWrapper className="col-xl-10 col-lg-12">
            <h2 className="title heading-1 mb-30">맞춤제작 포트폴리오</h2>
            <p>
              지속 가능한 미래를 위해 칼렛스토어가 함께 제공한 솔루션들을
              만나보세요
            </p>
          </Pf.TitleWrapper>
          <Pf.BodyWrapper className="row">
            <Pf.Sidebar className="primary-sidebar sticky-sidebar">
              <a
                className="btn mb-20"
                href="/customizing/customizing-products/"
                style={{ width: "100%", fontWeight: 500, fontSize: "1rem" }}
              >
                <i className="fi-rs-magic-wand mr-10" />
                맞춤 제작 하기
              </a>
              <div className="sidebar-widget widget-category-2 mb-20">
                <h5 className="section-title style-1 mb-20">포장재 솔루션</h5>
                <ul>
                  {dummyList?.portfolio &&
                    Object.keys(dummyList?.portfolio).map((el, i) => (
                      <li
                        className="hover-up"
                        onClick={() => handleClick(i, el)}
                        key={i}
                        style={{ cursor: "pointer" }}
                      >
                        <a
                          className={
                            active == i ? "cat-item text-brand" : "cat-item"
                          }
                        >
                          <i className="fi-rs-caret-right mr-5" />
                          {dummyList?.portfolio[el]}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </Pf.Sidebar>
            <Pf.ContentsWrapper>
              <div className="tab-content wow fadeIn animated ">
                <div className={"tab-pane fade show active"}>
                  <div className="product-grid-4 row">
                    {activeList &&
                      activeList.map((el, i) => (
                        <div className="col-lg-4 col-md-6 col-sm-6" key={i}>
                          <PortFolioSingleProduct portfolio={el} />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Pf.ContentsWrapper>
          </Pf.BodyWrapper>
        </Pf.Container>
        <PortfolioQuickView />
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

export default connect(mapStateToProps, null)(Portfolio);
